import { hashKey, QueryClient } from '@tanstack/react-query';
import { getApiEntityScopeCacheKey, isEntityIndependentRequest } from '@cdf/api-client-react';

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
        queryKeyHashFn: (queryKey) => hashKey([
          typeof queryKey[0] === 'string' && isEntityIndependentRequest(queryKey[0])
            ? ['identity'] : getApiEntityScopeCacheKey(),
          queryKey
        ])
      }
    }
  });
}
